export default "__VITE_ASSET__edf89d51__"